/**
 * Utility functions for company data
 */

export { getFirstCompanyUrl } from '../../../../../utils/company/first-company-url';

/**
 * Extract YouTube video ID from URL
 */
export function extractYouTubeVideoId(url?: string): string | null {
  if (!url) return null;
  
  // Handle various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
}



